import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    header: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  });
});
